import React from 'react';
import { ClubProfile } from '../../../../utils/interfaces';

interface CommonClubFieldsProps {
  clubName: string;
  club: ClubProfile;
  activeCategory: string;
  handleProfileChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const CommonClubFields: React.FC<CommonClubFieldsProps> = ({ clubName, club, activeCategory, handleProfileChange }) => {
  return (
    <>
      {activeCategory !== 'Putter' && (
        <div className="form-field">
          <label htmlFor={`${clubName}.distance`}>Carry (Yards)</label>
          <input
            type="number"
            id={`${clubName}.distance`}
            name={`${clubName}.distance`}
            value={club?.distance || ''}
            onChange={handleProfileChange}
            placeholder={
              activeCategory === 'Driver'
                ? "e.g., 250"
                : activeCategory === 'Fairway Woods'
                  ? "e.g., 220"
                  : activeCategory === 'Utilities'
                    ? "e.g., 200"
                    : activeCategory === 'Irons'
                      ? "e.g., 140"
                      : activeCategory === 'Wedges'
                        ? "e.g., 100"
                        : ""
            }
          />
        </div>
      )}
      <div className="form-field">
        <label htmlFor={`${clubName}.model`}>Model</label>
        <input
          id={`${clubName}.model`}
          name={`${clubName}.model`}
          value={club?.model || ''}
          onChange={handleProfileChange}
          placeholder="e.g., TaylorMade SIM2"
          maxLength={40}
        />
      </div>
      {activeCategory === 'Putter' && (
        <div className="form-field">
          <label htmlFor={`${clubName}.shaft`}>Shaft</label>
          <input
            id={`${clubName}.shaft`}
            name={`${clubName}.shaft`}
            value={club?.shaft || ''}
            onChange={handleProfileChange}
              placeholder="e.g. Ventus Blue Stiff 60g"
            maxLength={40}
          />
        </div>
      )}
      <div className="form-field">
        <label htmlFor={`${clubName}.notes`}>Notes</label>
        <input
          id={`${clubName}.notes`}
          name={`${clubName}.notes`}
          value={club?.notes || ''}
          onChange={handleProfileChange}
          placeholder="Any specific issues or preferences? Ideal distance, feel, etc."
          maxLength={100}
        />
      </div>
    </>
  );
};

export default CommonClubFields;
